import { string, object, number } from 'yup';

const clientsSchema = object().shape({
  name: string().required(),
  mobileNumber: number().required()
});

export default clientsSchema;
